import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["data-cmp-id"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("span", {
    role: "presentation",
    "data-cmp-id": $options.cmpId
  }, null, 8, _hoisted_1);
}